export const REPORT_TIME_ZONE = 'Australia/Sydney'

type DateInput = Date | string | number | null | undefined

function toDate(value: DateInput): Date | null {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const date = value instanceof Date ? value : new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

function getParts(
  value: DateInput,
  options: Intl.DateTimeFormatOptions,
): Record<string, string> | null {
  const date = toDate(value)
  if (!date) {
    return null
  }

  const formatter = new Intl.DateTimeFormat('en-AU', {
    timeZone: REPORT_TIME_ZONE,
    ...options,
  })

  return formatter.formatToParts(date).reduce<Record<string, string>>((acc, part) => {
    if (part.type !== 'literal') {
      acc[part.type] = part.value
    }
    return acc
  }, {})
}

export function formatReportDate(value: DateInput): string {
  const parts = getParts(value, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })

  if (!parts) {
    return ''
  }

  return `${parts.day} ${parts.month} ${parts.year}`
}

export function formatReportDateTime(value: DateInput): string {
  const parts = getParts(value, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  })

  if (!parts) {
    return ''
  }

  const dayPeriod = (parts.dayPeriod ?? '').toUpperCase()
  const timeZoneName = parts.timeZoneName ? ` ${parts.timeZoneName}` : ''

  return `${parts.day} ${parts.month} ${parts.year}, ${parts.hour}:${parts.minute} ${dayPeriod}${timeZoneName}`.trim()
}

export function formatReportDateWithTimeZone(value: DateInput): string {
  const formattedDate = formatReportDate(value)
  return formattedDate ? `${formattedDate} (${REPORT_TIME_ZONE})` : ''
}